import CryptoJS from "crypto-js";

export function getPersistCheckoutFromStorage(){
  try{
    let storage = decryptGuestCheckoutStorage(JSON.parse(window.localStorage.getItem('persist:checkout')));
    return storage === null ? {} : storage;
  }catch(e){
    console.warn(`Failed to get persist checkout data from storage`, e)
    removeFromLocalStorage('persist:checkout')
    throw e
  }
}

export function setPersistCheckoutFromStorage(storageName, data){
  if(data) {
    try {
      window.localStorage.setItem('persist:guest:checkout:status', 'true');
      data = JSON.stringify(encryptGuestCheckoutStorage(JSON.parse(data)));
      return window.localStorage.setItem(storageName, data)
    } catch (e) {
      console.warn(`Failed to get persist checkout data from storage`, e)
      throw e
    }
  }
}

export function getStorage(storageName){
  try{
    return window.localStorage.getItem(storageName)
  }catch(e){
    console.warn(`Failed to get storage`, e)
    throw e
  }
}

export function hasStorage(storageName){
  return getStorage(storageName) !== null
}

export function setStorage(storageName, data){
  try{
    return window.localStorage.setItem(storageName, data)
  }catch(e){
    console.warn(`Failed to set storage`, e)
    throw e
  }
}

/* This method is responsible for encrypt to persist:checkout local storage value*/
const encryptGuestCheckoutStorage = (checkoutStorage) => {
  const encryptCheckoutStorage = {};
  try {
    if (checkoutStorage && Object.keys(checkoutStorage).length > 0) {
      const {shoppingRequest, lineLevelSessionInfos, invalidIds} = checkoutStorage;
      encryptCheckoutStorage['shoppingRequest'] = getEncryptString(shoppingRequest);
      encryptCheckoutStorage['lineLevelSessionInfos'] = getEncryptString(lineLevelSessionInfos);
      encryptCheckoutStorage['invalidIds'] = invalidIds ? getEncryptString(invalidIds) : null;
    }
    return encryptCheckoutStorage;
  } catch (e) {
    console.warn(`Failed to set storage`, e)
    removeFromLocalStorage('persist:checkout')
    return encryptCheckoutStorage;
  }
}

/* This method is responsible for encrypting the given text value */
const getEncryptString = (value) => {
  const encrypted = CryptoJS.AES.encrypt(value, 'pgEYVPzG14pZiB7BjdU65VtbuTDViar4');
  return encrypted.toString();
}

/* This method is responsible for decryption the given text value */
const getDecryptString = (value) => {
  try {
    const bytes = CryptoJS.AES.decrypt(value, 'pgEYVPzG14pZiB7BjdU65VtbuTDViar4');
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
     return null;
  }
}

/* This method is responsible for decrypt to persist:checkout local storage value*/
const decryptGuestCheckoutStorage = (checkoutStorage) => {
  const decryptCheckoutStorage = {};
  try {
    if (checkoutStorage && Object.keys(checkoutStorage).length > 0) {
      const {shoppingRequest, lineLevelSessionInfos, invalidIds} = checkoutStorage;
      decryptCheckoutStorage['shoppingRequest'] = shoppingRequest && JSON.parse(getDecryptString(shoppingRequest.replace(/(^"|"$)/g, '')));
      const decryptedLineLevelSessionInfos = getDecryptString(lineLevelSessionInfos.replace(/(^"|"$)/g, ''));
      decryptCheckoutStorage['lineLevelSessionInfos'] = lineLevelSessionInfos && decryptedLineLevelSessionInfos !== '' && JSON.parse(decryptedLineLevelSessionInfos);
      decryptCheckoutStorage['invalidIds'] = invalidIds && invalidIds !== 'null' ? JSON.parse(getDecryptString(invalidIds.replace(/(^"|"$)/g, ''))) : null;
    }
    return Object.keys(decryptCheckoutStorage).length === 0 ? null : decryptCheckoutStorage;
  } catch (e) {
    console.warn(`Failed to set storage`, e)
    removeFromLocalStorage('persist:checkout')
    return decryptCheckoutStorage;
  }
}

/**
 * Remove a value from local storage
 * @param {string} key - The key of the value to remove
 */
const removeFromLocalStorage = (key) => {
  if (typeof(Storage) !== "undefined") {
    window.localStorage.removeItem(key);
    console.log(`Value with key ${key} was removed from local storage`);
  } else {
    console.error("Local storage is not available.");
  }
}
